import React, { FunctionComponent } from 'react';
import { faImages } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconImages: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faImages} />;

export { BrassIconImages };
